/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */

/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import { useTranslation } from "react-i18next";
// import { withRouter } from "react-router-dom";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { SidebarData } from "./sidebardata";
import { useUnsavedChangesGate } from "context/unsavedChangesContext";

const Sidebar = () => {
  const location = useLocation();
  // const pathname = location.pathname.split("/")[1];
  const pathname = location.pathname;

  // console.log("pageurl", pathname);
  const { user, userLoading } = useSelector((state) => state.user);


  const [sidebarData, setSidebarData] = useState(SidebarData); 
  const [isSidebarExpanded, setSidebarExpanded] = useState(false);
  const [isMouseOverSidebar, setMouseOverSidebar] = useState(false);
  const [submenuDrop ,setSubmenudrop] = useState(false);
  const [permissions ,setPermissions] = useState([]);


  useEffect(()=> {

    if(user?.role){
      const permissionCodes = user?.role?.permissions?.map(item=> item.code) || [];
      setPermissions(permissionCodes);
    }


  },[user])

  const hasOrgChartAccess =
    permissions?.includes("org_chart") ||
    user?.modules?.some?.((m) => m.code === "org_chart");

  

  useEffect(() => {
    if (
      isMouseOverSidebar &&
      document.body.classList.contains("mini-sidebar")
    ) {
      document.body.classList.add("expand-menu");
      return;
    }
    document.body.classList.remove("expand-menu");
  }, [isMouseOverSidebar]);


  

  const handleMouseEnter = () => {
    setMouseOverSidebar(true);
  };

  const handleMouseLeave = () => {
    setMouseOverSidebar(false);
  };
  const { t } = useTranslation();


  const expandSubMenus = (menu) => {
    sessionStorage.setItem('menuValue', menu.menuValue);
    const updatedAdminSidebar = sidebarData.map((section) => {
      return { 
        ...section,
        showSubRoute: menu.menuValue == section.menuValue ? !menu.showSubRoute : false,
      };

      // console.log(updatedSection)

      // menu.menuValue != section.menuValue
      //     ? {
      //         ...updatedSection,
      //         showSubRoute: false,
      //       }
      //     : {
      //         ...updatedSection,
      //         showSubRoute: !menu.showSubRoute,
      //       },
     
      // return updatedSection;
    });
    setSidebarData(updatedAdminSidebar);
  };

  const arrowDrop=()=>{
    setSubmenudrop(!submenuDrop);
  }

  // Unsaved-changes gate for the full-width form slide-overs, which stay open
  // beside a now-clickable sidebar (see components/modelpopup/baseModal.jsx).
  //
  // One capture-phase handler on the root rather than a guard threaded through
  // the five <Link>s below: this file's markup is deeply nested and easy to add
  // a sixth link to, and a single choke point cannot be forgotten. Capture also
  // runs before the Link's own onClick, which is what lets the handler below
  // call preventDefault in time for react-router to see it and skip the
  // navigation. It deliberately does NOT stop propagation — see the comment on
  // the preventDefault call itself for why swallowing the event would break the
  // one link that is both a route and a submenu toggle.
  //
  // NOTE: this covers sidebar navigation only. react-router 6.30 ships
  // `useBlocker`, which would also catch the browser Back button and in-app
  // navigation from anywhere else — but it requires a data router
  // (`useDataRouterContext` invariant) and this app mounts a plain
  // <BrowserRouter> (Routes/Approuter/index.jsx:59). Back-button and
  // address-bar navigation are therefore NOT guarded; converting the app to
  // createBrowserRouter is its own change.
  const navigate = useNavigate();
  const { hasGuard, confirmLeave } = useUnsavedChangesGate();

  const handleNavCaptureClick = (event) => {
    // Nothing registered means no slide-over is open — leave the event
    // completely untouched, which is the overwhelmingly common case.
    if (!hasGuard()) return;

    const anchor = event.target?.closest?.("a[href]");
    if (!anchor) return;

    const href = anchor.getAttribute("href");
    // `to="#"` is the submenu expander, not a navigation.
    if (!href || href === "#") return;

    // Let the browser keep handling "open in a new tab/window" — those don't
    // navigate this document, so there is nothing to lose.
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    // preventDefault only — deliberately NOT stopPropagation. react-router's
    // <Link> runs the caller's own onClick first and then navigates only
    // `if (!event.defaultPrevented)` (react-router-dom/dist/index.js:787-791),
    // so preventing the default is enough to suppress the navigation while
    // leaving sibling behaviour on the same anchor intact. One link in the
    // markup below is both a route and a submenu toggle
    // (`<Link to={subMenus.route} onClick={arrowDrop}>`, the showMenuRoute
    // branch); stopping propagation here would have swallowed that toggle.
    event.preventDefault();
    confirmLeave().then((mayLeave) => {
      if (mayLeave) navigate(href);
    });
  };

  return (
    <div
      className={`sidebar ${isSidebarExpanded ? "" : "hidden"}`}
      id="sidebar"
      onClickCapture={handleNavCaptureClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="sidebar-inner slimscroll" style={{ height: "calc(100vh - 60px)", overflow: "hidden" }}>
        <div id="sidebar-menu" className="sidebar-menu" style={{ height: "100%", display: "flex", flexDirection: "column" }}>  
          <div style={{ flex: 1, minHeight: 0, overflow: "hidden" }}>
            <Scrollbars
              autoHide={false}
              autoHideTimeout={1000}
              autoHideDuration={200}
              style={{ height: "100%" }}
              thumbMinSize={30}
              universal={false}
              hideTracksWhenNotNeeded={true}
            >
              <ul className="sidebar-vertical" id="veritical-sidebar"> 
         
              {sidebarData.map((menu, menuIndex) => {
                // Visibility rules:
                //  - If the menu has its own `code`, gate on that code.
                //  - Otherwise, if it has submenus, show the parent only when at
                //    least one submenu is accessible (either no `code` or a
                //    matching permission). This prevents the parent from
                //    rendering when the user has no access to any child.
                //  - Otherwise, show always (legacy items with neither).
                const hasMenuCode = !!menu?.code;
                const hasSubMenus = Array.isArray(menu?.subMenus) && menu.subMenus.length > 0;
                const anyChildVisible = hasSubMenus
                  && menu.subMenus.some((s) => !s?.code || permissions?.includes(s?.code));
                const showMenu = hasMenuCode
                  ? permissions?.includes(menu.code)
                  : hasSubMenus ? anyChildVisible : true;
                if (showMenu) {
                  return (
                    <React.Fragment key={`menu-${menuIndex}-${menu.code}`}>
                      {/* <li className="menu-title" key={index + 1}>
  
                        <span>{t(mainTitle.tittle)}</span>
                        {mainTitle?.tittle === "CRM" ? (
                          <small class="newly-added-features">New</small>):("")
                        }
                      </li> */}
                     
                           
                            <React.Fragment key={`menu-content-${menuIndex}`}>
                              {menu.hasSubRoute === false ? (
                                <li key={menuIndex + 1}  className={pathname == menu.route ? "active" : ""}>
                                  <Link
                                    to={menu.route}
                                   
                                  >
                                    {/* {menu.icon} */}
                                    <i className={menu?.icon}/>
                                     <span>{t(menu.menuValue)}</span>
                                  </Link>
                                </li>
                              ) : (
                                <li className="submenu">
                                  <Link
                                    to="#"
                                    onClick={() => expandSubMenus(menu)}
                                    
                                    className={
                                      menu.showSubRoute  ? 'subdrop' : ''
                                    } 
                                  >
                                   
                                    <i className={menu?.icon}/>
                                    <span 
                                    // className={menu?.menuValue == "Employees" ? "noti-dot" : ""}
                                    >{t(menu.menuValue)}</span>
                                    <span className="menu-arrow">
                                    
                                    </span>
                                  </Link>
                                  <ul
                                    style={{
                                      display: menu.showSubRoute
                                        ? 'block'
                                        : 'none',
                                    }}
                                  >
                                    {menu.subMenus?.map(
                                      (
                                        subMenus,
                                        subMenu,
                                      ) => {
                                        const hasPermission = !subMenus?.code || permissions?.includes(subMenus?.code);
                                        if(hasPermission){
                                          return (
                                          
                                            <React.Fragment key={`submenu-${subMenu}-${subMenus.code}`}>
                                          
                                          {/* {console.log(subMenus?.showMenuRoute)} */}
                                          {subMenus?.showMenuRoute === true ? (
                                              <li key={subMenu + 1}>
                                                <Link
                                                  to={subMenus.route}
                                                
    
                                                  className={submenuDrop ? "subdrop":""}
                                                  onClick={arrowDrop}
                                                  
                                                >
                                                  {t(subMenus.menuValue)}
                                                  <span className="menu-arrow" ></span>
                                                </Link>
    
                                                <ul style={{display: submenuDrop ? "block":"none"}}>
                                                  {subMenus?.subMenusValues?.map((value,index)=>{
                                                    
                                                    return(
                                                <li key={index}>
                                                  <span>
                                                <Link to={value.route}><span>{t(value.menuValue)} </span></Link>
                                                </span>
                                                </li>)})
                                          }
                                          </ul>
                                                   </li>) :(
                                                                                          
                                                  <li key={subMenu + 1}>
                                                  <Link
                                                    to={subMenus.route}
                                                    
                                                    className={pathname== subMenus?.route ? "active" : ""}
                                                  >
                                                    {t(subMenus.menuValue)}
                                                  </Link>
                                                  
                                                  <ul>
                                                  {subMenus?.subMenusValues?.map((value,index)=>{
                                                    return(
                                                <li key={index}>
    
                                                <Link to={value.route} className={pathname== value?.route ? "active" : ""}
                                                    >{t(value.menuValue)}</Link>
                                                </li>)})
                                                }
                                                </ul>
                                                </li>
                                              )
    
                                        }
    
                                              
                                            </React.Fragment>
                                          );        
                                        }
                                        return null
                                        
                                      },
                                    )}
                                  </ul>
                                </li>
                              )}
                            </React.Fragment>
                          
                       
                    </React.Fragment>
                  );
                }
                return null;
                return <></>
               
              })}
            </ul>
            </Scrollbars>
          </div>
        </div>
      </div>

    


    </div>
  );
};

export default Sidebar;
